import { Tabs, TabsList, TabsTrigger } from "@b2b/ui-components";
import { ShoppingCart, Package } from "lucide-react";

type TradeRole = "buyer" | "supplier" | "both";

interface RoleSelectorProps {
  tradeRole: TradeRole;
  onRoleChange: (role: TradeRole) => void;
}

const roles = [
  { value: "buyer", label: "Buy", icon: ShoppingCart },
  { value: "supplier", label: "Sell", icon: Package },
];

const RoleSelector = ({ tradeRole, onRoleChange }: RoleSelectorProps) => (
  <div className="space-y-4">
    <label className="text-lg font-semibold text-gray-800">I want to:</label>
    <Tabs value={tradeRole} onValueChange={(value) => onRoleChange(value as TradeRole)}>
      <TabsList className="grid w-full grid-cols-2 bg-gray-100 rounded-lg">
        {roles.map(({ value, label, icon: Icon }) => (
          <TabsTrigger
            key={value}
            value={value}
            className="text-sm flex items-center gap-2 data-[state=active]:bg-orange-500 data-[state=active]:text-white"
          >
            <Icon className="w-4 h-4" />
            {label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  </div>
);

export default RoleSelector;
